import register from '../../../../global/js/registry';
export default register('a-quantity-selector', () => import(/* webpackMode: "lazy" */ './a-quantity-selector.controller'));
